type RequestIdProps = {
  value: string;
};

export function RequestId({ value }: RequestIdProps) {
  return (
    <p className="request-id">
      Request ID <code>{value}</code>
    </p>
  );
}
